import axios from "axios";
import { ActionContext, Module } from "vuex";

import { Evidence } from "@/types";
import { auth as manager } from "@/auth";
import { analytics } from "@/analytics";
import { RootState } from "@/store/root";
import { repository } from "@/codes";

const compare = (first: Evidence, second: Evidence) => {
  if (first.spans.length === 0) return -1;
  if (second.spans.length === 0) return 1;
  const [a, b] = [first.spans[0][0], second.spans[0][0]];
  return a > b ? 1 : a < b ? -1 : 0;
};

interface RawEvidence {
  code: string;
  codename: string;
  tokspans: any[];
  better_matches: string[];
  lacking: string[];
  pratio: number;
  score: number;
  prereqs: {
    required: boolean;
    reqlist: string[];
  };
}

export const verify: Module<{}, RootState> = {
  namespaced: true,
  actions: {
    async update(context: ActionContext<{}, RootState>) {
      if (analytics.enabled) {
        analytics.record({ name: "verify" });
      }

      // eslint-disable-next-line no-control-regex
      const text = context.rootState.raw.replace(/[^\x00-\x7F]/g, "");

      await context.dispatch("matches/update", text, { root: true });

      const verified = context.rootState.codes
        .split(" ")
        .filter(Boolean)
        .filter(code =>
          repository
            .all("codes")
            .map(code => code.id)
            .includes(code)
        );

      const response = await axios.post(
        (context.rootState as any).settings.current.endpoints.verify,
        {
          documents: [{ text }],
          patient: {},
          codings: {
            system: "icd10",
            codes: verified
          }
        },
        {
          headers: manager.enabled ? await manager.headers() : {}
        }
      );

      const evidences = response.data.icd.imatches
        .filter((match: any) => Object.keys(match).length)
        .map((evidence: RawEvidence) => ({
          id: evidence.code,
          desc: evidence.codename,
          spans: evidence.tokspans.filter(span => span.length),
          billable: true,
          score: evidence.score,
          pratio: evidence.pratio,
          better_matches: evidence.better_matches.filter(Boolean),
          lacking: evidence.lacking.filter(Boolean),
          prereqs: {
            required: evidence.prereqs.required,
            codes: evidence.prereqs.reqlist
          },
          type: verified.includes(evidence.code) ? "verified" : "suggested"
        }));

      context.commit("evidences/UPDATE", evidences.sort(compare), {
        root: true
      });
    }
  }
};
